import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import * as React from "react";
import { SaveButton, SimpleForm, Toolbar, useNotify } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { useAppDataProvider } from "../../../../dataprovider";

export const CustomClearanceOrdinoDateDialog = props => {
  const [open, setOpen] = React.useState(false);
  const dataProvider = useAppDataProvider();
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    props?.handleClose?.();
    setOpen(false);
  };
  const handleSubmit = data => {
    setLoading(true);
    dataProvider
      .putRequestUnserviceable(data)
      .then(result => {
        notify(`Record Updated`, "success", false, true);
        handleClose();
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };
  const UserCustomToolbar = props => (
    <Toolbar {...props} placeholder="" {...props} style={{ flexDirection: "row-reverse" }}>
      <SaveButton disabled={loading} />
    </Toolbar>
  );
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>Ordino Date</DialogTitle>
      <DialogContent>
        <DialogContentText>Enter Ordino Date</DialogContentText>

        <SimpleForm
          toolbar={<UserCustomToolbar />}
          resource="/requestunserviceables"
          basePath=""
          record={props?.record?.unserviceable}
          save={handleSubmit}
        >
          <CustomDatetime
            fullWidth
            source="ordinoDate"
            label="Ordino Date"
            inputVariant={"dialog"}
            variant="outlined"
            showTime
          />
        </SimpleForm>
      </DialogContent>
    </Dialog>
  );
};

export default CustomClearanceOrdinoDateDialog;
